/* Buy 3 Get 2 homepage band v1.1 (2026-09-12, Adelaide: "move it above the
   banner"). ADDITIVE: inserts the tips-offer band directly BEFORE the
   "We make science accessible" hero (.fv3-hero9) inside #fv3-app, so it sits
   between the header and the hero. The hero itself is never touched. The band removes
   itself whenever the hero is not on screen (hash routes to search/PDP), so
   it exists only on the home view. Loaded from sections/filtrous-v3-app.liquid;
   remove that loader line (and this asset) when the offer ends Sept 30. */
(function () {
  'use strict';
  if (window.__fiB3g2Home) return;
  window.__fiB3g2Home = true;

  var IMG = 'https://cdn.shopify.com/s/files/1/0684/8823/3234/files/PTF-GS-0010_-_Main.jpg?v=1774923819&width=360';
  var ID = 'fi-b3g2-home';

  function build() {
    var a = document.createElement('a');
    a.id = ID;
    a.href = '/pages/buy-3-get-2';
    a.style.cssText = 'display:flex;align-items:center;gap:24px;border-radius:14px;background:#082F4B;padding:18px 28px 18px 18px;text-decoration:none;margin:14px 16px 6px;';
    a.innerHTML =
      '<span style="flex-shrink:0;width:128px;height:104px;background:#FFFFFF;border-radius:11px;display:flex;align-items:center;justify-content:center;overflow:hidden;">' +
        '<img src="' + IMG + '" alt="10\u00b5L sterile filter pipette tips" loading="lazy" style="width:100%;height:100%;object-fit:contain;padding:6px;box-sizing:border-box;">' +
      '</span>' +
      '<span style="flex:1 1 auto;min-width:0;display:block;">' +
        '<span style="display:inline-flex;background:#CBFFF6;color:#082F4B;font-size:10.5px;font-weight:700;letter-spacing:1.5px;padding:4px 11px;border-radius:999px;">LIMITED-TIME \u00b7 SEPT 10\u201330, 2026</span>' +
        '<span style="display:block;font-size:22px;font-weight:800;color:#FFFFFF;margin-top:8px;font-family:var(--filtrous-font,\'DM Sans\',sans-serif);">Your 10\u00b5L filter tips just went <span style="color:#21D6B3;">40% off.</span></span>' +
        '<span style="display:block;font-size:12.5px;color:rgba(255,255,255,0.75);margin-top:3px;">Buy 3 boxes, get 2 free \u2014 applies automatically at 3 items. Ends Sept 30.</span>' +
      '</span>' +
      '<span style="flex-shrink:0;display:inline-flex;align-items:center;gap:8px;background:linear-gradient(135deg,#21D6B3,#CBFFF6);color:#082F4B;font-weight:700;font-size:13.5px;padding:12px 24px;border-radius:8px;">Shop the tips ' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#082F4B" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg></span>';
    return a;
  }

  function sync() {
    var hero = document.querySelector('#fv3-app .fv3-hero9');
    var band = document.getElementById(ID);
    if (hero && hero.isConnected) {
      if (!band || !band.isConnected) hero.insertAdjacentElement('beforebegin', build());
    } else if (band) {
      band.remove();
    }
  }

  function boot() {
    sync();
    new MutationObserver(sync).observe(document.getElementById('fv3-app') || document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
